import { render, staticRenderFns } from "./sign-out.vue?vue&type=template&id=593a87c7&scoped=true&"
import script from "./sign-out.vue?vue&type=script&lang=ts&"
export * from "./sign-out.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593a87c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('593a87c7')) {
      api.createRecord('593a87c7', component.options)
    } else {
      api.reload('593a87c7', component.options)
    }
    module.hot.accept("./sign-out.vue?vue&type=template&id=593a87c7&scoped=true&", function () {
      api.rerender('593a87c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/view/authentication/sign-out.vue"
export default component.exports